import React from 'react';
import {Layout, Quantum} from '@republic/bits';
import {createComponent} from '@republic/react-foundation';
import colors from '../../core/components/colors';
import AccountInfoBalance from './AccountInfoBalance';

export default (
    createComponent(
        'AccountBase',
        {},
        ({children}) => (
            <Quantum leaps={[
                {formWidth: '100%', pagePadding: {top: 0, bottom: 0}, contentPadding: 1, border: 'none'},
                ['tiny', {formWidth: '360px'}],
                ['small', {formWidth: '430px', pagePadding: {top: 1, bottom: 1}, border: {width: 1, color: colors.medium_light_gray}}],
                ['medium', {formWidth: '460px', pagePadding: {top: 2, bottom: 2}, contentPadding: 3}]]}>

                {({formWidth, pagePadding, contentPadding, border}) => (
                    <Layout
                        color={colors.white_gray}
                        padding={pagePadding}
                        minHeight="90vh"
                        align="center"
                        justify="center">

                        <Layout
                            margin="auto"
                            position="relative"
                            width={formWidth}>

                            <Layout
                                color={colors.white}
                                border={border}
                                margin="auto"
                                minHeight="90vh"
                                width="100%">

                                <AccountInfoBalance />
                                <Layout padding={contentPadding}>
                                    {children}
                                </Layout>
                            </Layout>
                        </Layout>
                    </Layout>)}
            </Quantum>)));
